/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Aggregated totals in transactions list response
 * @export
 * @interface TransactionsSummary
 */
export interface TransactionsSummary {
    /**
     * 
     * @type {number}
     * @memberof TransactionsSummary
     */
    totalIn?: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionsSummary
     */
    totalOut?: number;
}

/**
 * Check if a given object implements the TransactionsSummary interface.
 */
export function instanceOfTransactionsSummary(value: object): value is TransactionsSummary {
    return true;
}

export function TransactionsSummaryFromJSON(json: any): TransactionsSummary {
    return TransactionsSummaryFromJSONTyped(json, false);
}

export function TransactionsSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransactionsSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'totalIn': json['totalIn'] == null ? undefined : json['totalIn'],
        'totalOut': json['totalOut'] == null ? undefined : json['totalOut'],
    };
}

export function TransactionsSummaryToJSON(json: any): TransactionsSummary {
    return TransactionsSummaryToJSONTyped(json, false);
}

export function TransactionsSummaryToJSONTyped(value?: TransactionsSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalIn': value['totalIn'],
        'totalOut': value['totalOut'],
    };
}

